import { render } from "./Washed.vue?vue&type=template&id=06bc5a45&scoped=true"
import script from "./Washed.vue?vue&type=script&lang=js"
export * from "./Washed.vue?vue&type=script&lang=js"

import "./Washed.vue?vue&type=style&index=0&id=06bc5a45&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06bc5a45"]])

export default __exports__